import {
  IRichTextRepository,
} from "../../../domain/document";

import { AuthenticatedService } from "../..";
import { TimeMeasure } from "../../../utilities";

export class RichTextRepository extends AuthenticatedService implements IRichTextRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  getAdjustedHeight(executionMode: string, width: number, height: number, richText: string): number {
    const url = "/api/richtext/adjust-height";
    const data = {
      executionMode,
      width,
      height,
      richText
    };
    // 通信を同期で行うためXMLHttpRequestを利用する
    let result: number = 0;
    TimeMeasure.log(
      "POST: " + url + " ",
      () => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", url + "?token=" + this.token, false);
        xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
        xhr.setRequestHeader("Authorization", "Bearer " + this.token);
        xhr.onload = function() {
          if (xhr.readyState === 4 && xhr.status === 200 && xhr.responseText) {
            result = JSON.parse(xhr.responseText);
          }
        };
        xhr.send(JSON.stringify(data));
      },
      "token=" + this.token,
      TimeMeasure.debug
    );
    return result;
  }
}
